<template>
	
  <div class="p-grid nested-grid tab-card">
    <div class="p-col-12 p-md-6">
      <div :class="['p-grid', 'p-ai-center', {'gray':cycleDisabled}]">
        <div class="p-col-fixed p-text-center">
          <i :class="['cycle-spinner',{'cycle-spinner-spin':loader}]"><span :class="icon" style="font-size: 35px;"/></i>
        </div>
        <div class="p-col">
          <span>{{$t('mp.function_0.phases.'+operationalStatus)}}</span>
        </div>
      </div>
    </div>
    <div class="p-col-12 p-md-6">
      <div @click="tempUmidityDialog" :class="['p-grid', 'p-ai-center', {'gray': tempDisabled }, {'clickable': !tempDisabled && !readOnlyMode}]">
        <div class="p-col-fixed p-text-center">
          <span class="icon-air_temp"/>
        </div>
        <div class="p-col">
          <span>{{$t('details.cp.air_temp')}}</span>
        </div>
        <div class="p-col-fixed p-text-right">
          <span v-if="operationalStatus=='cool'">{{$functions.temperature(appliance.status.cellSetTemp, isCelsius)}}{{unit}}</span> 
          <span v-else>- {{unit}}</span> 
        </div>
        <div class="param-cta">
          <i v-if="!tempDisabled" class="pi pi-chevron-right" />
        </div>
      </div>
    </div>
    <div class="p-col-12 p-md-6">
      <div @click="tempUmidityDialog" :class="['p-grid', 'p-ai-center', {'gray': humidityDisabled || isNegative }, {'clickable': !(humidityDisabled || isNegative) && !readOnlyMode}]">
        <div class="p-col-fixed p-text-center">
          <span class="icon-humidity"/>
        </div>
        <div class="p-col">
          <span>{{$t('details.cp.humidity')}}</span>
        </div>
        <div class="p-col-fixed p-text-right">
          <span v-if="operationalStatus=='cool'">{{humidityLevel}}</span> 
          <span v-else>-</span> 
        </div>
        <div class="param-cta">
          <i v-if="!(humidityDisabled || isNegative)" class="pi pi-chevron-right" />
        </div>
      </div>
    </div>
    <div class="p-col-12 p-md-6">
      <div @click="doorsDialog" :class="['p-grid', 'p-ai-center', {'gray': doorsDisabled }, {'clickable': !doorsDisabled && !readOnlyMode}]">
        <div class="p-col-fixed p-text-center">
          <img :class="[{'fade':doorsDisabled}]" src="assets/irinox/icons/doors.svg" :alt="$t('details.cp.doors')"/>
        </div>
        <div class="p-col">
          <span>{{$t('details.cp.doors')}}</span>
        </div>
        <div class="p-col-fixed p-text-right door-counter">
          <div>{{doorsDisabled ? '-' : dailyOpenDoor1Counter}}</div>
          <div>{{doorsDisabled ? '-' : dailyOpenDoor2Counter}}</div>
        </div>
        <div class="param-cta">
          <i v-if="!doorsDisabled" class="pi pi-chevron-right" />
        </div>
      </div>
    </div>
    <div class="p-col-12 p-md-6">
      <div @click="defrostDialog" :class="['p-grid', 'p-ai-center', {'gray': defrostDisabled }, {'clickable': !defrostDisabled && !readOnlyMode}]">
        <div class="p-col-fixed p-text-center">
          <span class="icon-defrosting" style="font-size: 35px;"/>
        </div>
        <div class="p-col">
          <!-- <span v-if="operationalStatus=='defrost'">{{$t('details.cp.defrost_switched_on')}}</span>
          <span v-else>{{$t('details.cp.defrost_switched_off')}}</span> -->
          <span>{{$t('details.cp.defrost_switched_off')}}</span>
        </div>
        <div class="param-cta">
          <i v-if="!defrostDisabled" class="pi pi-chevron-right" />
        </div>
      </div>
    </div>
    <div class="p-col-12 p-md-6">
      <div @click="onoffDialog" :class="['p-grid', 'p-ai-center', {'gray': onoffDisabled }, {'clickable': !onoffDisabled && !readOnlyMode}]">
        <div class="p-col-fixed p-text-center">
          <img :class="[{'fade':onoffDisabled}]" src="assets/irinox/icons/onoff.svg" alt="ON/OFF"/>
        </div>
        <div class="p-col">
          <span v-if="operationalStatus!='standby'">{{$t('details.cp.onoff_switched_on')}}</span>
          <span v-else>{{$t('details.cp.onoff_switched_off')}}</span>
        </div>
        <div class="p-col-fixed p-text-right">
          <img :class="[{'fade':onoffDisabled}]"  v-if="operationalStatus!='standby'" src="assets/irinox/icons/switched_on.svg" :alt="$t('details.cp.onoff_switched_on')"/>
          <img :class="[{'fade':onoffDisabled}]" v-else src="assets/irinox/icons/switched_off.svg" :alt="$t('details.cp.onoff_switched_off')"/>
        </div>
        <div class="param-cta"></div>
      </div>
    </div>
  </div>

  <!--                    -->
  <!-- ERRORS and SUCCESS -->
  <!--                    -->
  <IrinoxDialogDark :visible="dialog.error" 
    mode="error" 
    :message="$t('details.cp.dialog_error')"
    :life="3000" 
    @update:visible="dialog.error = $event" />
  <IrinoxDialogDark :visible="dialog.blockingError" 
    mode="error" 
    :message="$t('details.cp.dialog_error')"
    :life="0" 
    @update:visible="dialog.blockingError = $event" />
  <IrinoxDialogDark :visible="dialog.success" 
    mode="success" 
    :message="$t('details.cp.dialog_success')"
    :life="3000" 
    @update:visible="dialog.success = $event" />

  <!--                -->
  <!-- DEFROST DIALOG -->
  <!--                -->
  <IrinoxDialogDark :visible="dialog.defrost_turn_on" 
    mode="confirm" 
    :leftB="$t('details.cp.defrost_dialog_cancel_button')" 
    @click:left-button="()=>{dialog.defrost_turn_on=!dialog.defrost_turn_on}" 
    :rightB="$t('details.cp.defrost_dialog_ok_button')" 
    @click:right-button="defrost(true)" 
    :message="$t('details.cp.defrost_turn_on_dialog')"
    icon="assets/irinox/icons/defrost_big.svg" />
  <IrinoxDialogDark :visible="dialog.defrost_turn_off" 
    mode="confirm" 
    :leftB="$t('details.cp.defrost_dialog_cancel_button')" 
    @click:left-button="()=>{dialog.defrost_turn_off=!dialog.defrost_turn_off}" 
    :rightB="$t('details.cp.defrost_dialog_ok_button')" 
    @click:right-button="defrost(false)" 
    :message="$t('details.cp.defrost_turn_off_dialog')"
    icon="assets/irinox/icons/defrost_big.svg" />

  <!--              -->
  <!-- ONOFF DIALOG -->
  <!--              -->
  <IrinoxDialogDark :visible="dialog.onoff_turn_on" 
    mode="confirm" 
    :leftB="$t('details.cp.onoff_dialog_cancel_button')" 
    @click:left-button="()=>{dialog.onoff_turn_on=!dialog.onoff_turn_on}" 
    :rightB="$t('details.cp.onoff_dialog_ok_button')" 
    @click:right-button="onoff(true)" 
    :message="$t('details.cp.onoff_turn_on_dialog')"
    icon="assets/irinox/icons/onoff_big.svg" />
  <IrinoxDialogDark :visible="dialog.onoff_turn_off" 
    mode="confirm" 
    :leftB="$t('details.cp.onoff_dialog_cancel_button')" 
    @click:left-button="()=>{dialog.onoff_turn_off=!dialog.onoff_turn_off}" 
    :rightB="$t('details.cp.onoff_dialog_ok_button')" 
    @click:right-button="onoff(false)" 
    :message="$t('details.cp.onoff_turn_off_dialog')"
    icon="assets/irinox/icons/onoff_big.svg" />

  <!--              -->
  <!-- DOORS DIALOG -->
  <!--              -->
  <IrinoxDialogDark :visible="dialog.doors" 
    mode="confirm" 
    :leftB="$t('details.cp.doors_dialog_cancel_button')" 
    @click:left-button="()=>{dialog.doors=!dialog.doors}" 
    :rightB="$t('details.cp.doors_dialog_ok_button')" 
    @click:right-button="doors()" 
    :message="$t('details.cp.doors_dialog')"
    icon="assets/irinox/icons/doors_big.svg" />

  <!--                      -->
  <!-- HUMIDITY TEMP DIALOG -->
  <!--                      -->
  <Dialog v-model:visible="dialog.humidityTemp" class="irinox-dialog-dark" :modal="true" 
      :closable="true" :dismissableMask="true" :draggable="false">
    
    <div class="irinox-dialog-dark-content">
      <div class="p-grid nested-grid p-jc-center controls">
        <div class="p-col">
          <Control v-model="setpoints.temperature" icon="icon-air_temp" :isTemperature="true" :min="cellSetTempMin" :max="cellSetTempMax" />
        </div>
        <div v-if="!isNegative" class="p-col">
          <Control v-model="setpoints.humidity" icon="icon-humidity" :min="setLevelHumidityMin" :max="setLevelHumidityMax" />
        </div>
      </div>
      <Button :label="$t('details.cp.humidityTemp_dialog_cancel_button')" @click="()=>{dialog.humidityTemp=!dialog.humidityTemp}" style="width: 150px"/>
      <Button :label="$t('details.cp.humidityTemp_dialog_ok_button')" class="p-button-secondary" @click="saveHumidityTemp" style="width: 150px"/>
    </div>

    <template #footer>
    </template>
  </Dialog>

</template>

<script>
import IrinoxDialogDark from '../../IrinoxDialogDark.vue';
import Control from '../Control.vue';
import cycles from "@/cycles";
import { mapGetters } from 'vuex';
import EventHubListenerService from '../../../service/EventHubListenerService';
import commands from "../../../../public/json/commands_mp_0.json"

export default {
    components: {
      IrinoxDialogDark,
      Control
    },
    props: {
      serialNumber: String
    },
    data() {
        return {
          cycles: cycles,
          commands: commands,
          dialog: {
            error: false,
            blockingError: false,
            success: false,
            defrost_turn_on: false,
            defrost_turn_off: false,
            onoff_turn_on: false,
            onoff_turn_off: false,
            doors: false,
            humidityTemp: false
          },
          setpoints: {
            humidity: null,
            temperature: null
          }
        };
    },
    computed: {
        ...mapGetters({
          personaltoken: 'userdata/personaltoken',
          unit: 'userdata/unit',
          role: 'userdata/role',
          deviceTwin: 'appliances/deviceTwin',
          isCelsius: 'userdata/isCelsius',
        }),
        readOnlyMode: function() {
          return this.role.includes('INTERNAL') || this.role==='SERVICE_SALES';
        },
        appliance: function() {
            return this.$store.getters['appliances/appliance'](this.serialNumber);
        },
        mode: function() {
          return this.appliance.status && this.appliance.status.mode!=null ? this.appliance.status.mode : 0;
        },
        operationalStatus: function() {
          switch(this.mode) {
            case 0:
              return "standby";
            case 1:
            case 2:
            case 3:
              return "cool";
            case 4:
              return "defrost";
            default:
              return "standby";
          }
        },
        cycleDisabled: function() {
          return !this.appliance.online || this.operationalStatus==="standby";
        },
        tempDisabled: function() {
          return !this.appliance.online || this.operationalStatus!=="cool";
        },
        humidityDisabled: function() {
          return !this.appliance.online || this.operationalStatus!=="cool";
        },
        doorsDisabled: function() {
          return !this.appliance.online;
        },
        defrostDisabled: function() {
          return !this.appliance.online || this.operationalStatus==="standby" || this.operationalStatus==="defrost";
        },
        onoffDisabled: function() {
          return !this.appliance.online;
        },
        humidityLevel: function() {
          // return this.deviceTwin && this.deviceTwin.parameters && this.deviceTwin.parameters["PRF"] && typeof this.deviceTwin.parameters["PRF"]==="string"? parseInt(this.deviceTwin.parameters["PRF"].substring(2)) : '-';
          return this.appliance.status && this.appliance.status.setLevelHumidity ? this.appliance.status.setLevelHumidity : '-';
        },
        dailyOpenDoor1Counter: function() {
          return this.appliance.status && this.appliance.status.dailyOpenDoor1Counter ? this.appliance.status.dailyOpenDoor1Counter : 0;
        },
        dailyOpenDoor2Counter: function() {
          return this.appliance.status && this.appliance.status.dailyOpenDoor2Counter ? this.appliance.status.dailyOpenDoor2Counter : 0;
        },
        cellSetTempMin: function() {
          return this.commands.modes[this.mode].cellSetTempMin*10;
        },
        cellSetTempMax: function() {
          return this.commands.modes[this.mode].cellSetTempMax*10;
        },
        setLevelHumidityMin: function() {
          return this.commands.modes[this.mode].setLevelHumidityMin;
        },
        setLevelHumidityMax: function() {
          return this.commands.modes[this.mode].setLevelHumidityMax;
        },
        loader: function() {
          return false;
          // return this.appliance.gamma && this.cycles.icons[this.appliance.gamma] && this.cycles.icons[this.appliance.gamma][this.mode] ? this.cycles.icons[this.appliance.gamma][this.mode].loader : false;
        },
        icon: function() {
          return this.appliance.gamma && this.cycles.icons[this.appliance.gamma] && this.cycles.icons[this.appliance.gamma][this.mode] ? this.cycles.icons[this.appliance.gamma][this.mode].icon : "";
        },
        isNegative: function() {
          return this.appliance.status && this.appliance.status.TCell<=0;
        }
    },
    created() {
      this.eventHubListenerService = new EventHubListenerService();
    },
    methods: {
      tempUmidityDialog() {
        if(this.tempDisabled || this.humidityDisabled || this.readOnlyMode) {
          return;
        }
        this.setpoints.humidity = typeof this.humidityLevel === "number" ? this.humidityLevel : 0;
        this.setpoints.temperature = this.appliance.status.cellSetTemp;
        this.dialog.humidityTemp = true;
      },
      defrostDialog() {
        if(this.defrostDisabled || this.readOnlyMode) {
          return;
        }
        // if(this.appliance.status.operationalStatus!='defrost') {
        //   this.dialog.defrost_turn_on = true;
        // } else {
        //   this.dialog.defrost_turn_off = true;
        // }
        this.dialog.defrost_turn_on = true;
      },
      defrost(turnOn) {
        if(turnOn) {
          this.setOperationalStatus("defrost");
        } else {
          this.setOperationalStatus("cool");
        }
      },
      onoffDialog() {
        if(this.onoffDisabled || this.readOnlyMode) {
          return;
        }
        if(this.appliance.status.mode===0) {
          this.dialog.onoff_turn_on = true;
        } else {
          this.dialog.onoff_turn_off = true;
        }
      },
      onoff(turnOn) {
        if(turnOn) {
          this.setOperationalStatus("cool");
        } else {
          this.setOperationalStatus("standby");
        }
      },
      setOperationalStatus(os) {

        let data = {
          operationalStatus: os
        }

        this.dialog.defrost_turn_on = false;
        this.dialog.defrost_turn_off = false;
        this.dialog.onoff_turn_on = false;
        this.dialog.onoff_turn_off = false;
        this.eventHubListenerService.postSetOperationalStatus(this.personaltoken, this.serialNumber, data)
          .then((data) => {
            if(data.code=="200") {
              this.dialog.success = true;
              // let app = this.$functions.clone(this.appliance);
              // app.status.operationalStatus = os;
              // this.$store.commit('appliances/applianceDetails', app);
            } else {
              console.error("EXCEPTION "+JSON.stringify(data));
              this.dialog.error = true;
            }
          })
          .catch(error => {
            console.error("EXCEPTION "+error);
            this.dialog.error = true;
          });
      },
      doorsDialog() {
        if(this.doorsDisabled || this.readOnlyMode) {
          return;
        }
        this.dialog.doors = true;
      },
      doors() {

        let data = {
          resetDoorsCounter: 1
        }

        this.dialog.doors = false;
        this.eventHubListenerService.postResetOpenDoorCounter(this.personaltoken, this.serialNumber, data)
          .then((data) => {
            if(data.code=="200") {
              this.dialog.success = true;
              let app = this.$functions.clone(this.appliance);
              app.status.dailyOpenDoor1Counter = 0;
              app.status.dailyOpenDoor2Counter = 0;
              this.$store.commit('appliances/applianceDetails', app);
            } else {
              console.error("EXCEPTION "+JSON.stringify(data));
              this.dialog.error = true;
            }
          })
          .catch(error => {
            console.error("EXCEPTION "+error);
            this.dialog.error = true;
          });
      },
      saveHumidityTemp() {

        let data = {
          cellSetTemp: this.setpoints.temperature,
        }

        if(!this.isNegative) {
          data.setLevelHumidity = this.setpoints.humidity;
        }

        this.dialog.humidityTemp = false;
        this.eventHubListenerService.postSetSetpoint(this.personaltoken, this.serialNumber, data)
          .then((data) => {
            if(data.code=="200") {
              this.dialog.success = true;
              let app = this.$functions.clone(this.appliance);
              app.status.cellSetTemp = this.setpoints.temperature;
              if(!this.isNegative) {
                app.status.setLevelHumidity = this.setpoints.humidity;
              }
              this.$store.commit('appliances/applianceDetails', app);
            } else {
              console.error("EXCEPTION "+JSON.stringify(data));
              this.dialog.error = true;
            }
          })
          .catch(error => {
            console.error("EXCEPTION "+error);
            this.dialog.error = true;
          });

      }
    }
}
</script>

<style scoped>

</style>